import React from 'react';
import { map, filter } from 'ramda';

import Chip from 'material-ui/Chip';

import TextField from '../basic/TextField';

const KEY = {
  backspace: 8,
  tab: 9,
  enter: 13,
  space: 32
};

const INVALID_CHARS = /[^a-zA-Z0-9-_]/g;

class Chips extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chips: []
    };
  }

  componentDidMount() {
    this.setChipsFromProps(this.props.chips);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.chips !== nextProps.chips) {
      this.setChipsFromProps(nextProps.chips);
    }
  }

  setChipsFromProps(chips) {
    if (this.props.onChange) {
      this.setState({ chips });
    }
  }

  setChips(chips) {
    if (this.props.onChange) {
      this.props.onChange(chips);
    } else {
      this.setState({ chips });
    }
  }

  onKeyDown = event => {
    const keyPressed = event.which;
    if (keyPressed === KEY.space || (keyPressed === KEY.tab && event.target.value)) {
      event.preventDefault();
      this.updateChips(event);
    } else if (keyPressed === KEY.backspace) {
      const chips = this.state.chips;
      if (!event.target.value && chips.length) {
        this.handleDeleteChip(chips[chips.length - 1]);
      }
    }
  };
  clearInvalidChars = event => {
    let value = event.target.value;

    if (INVALID_CHARS.test(value)) {
      event.target.value = value.replace(INVALID_CHARS, '');
    } else if (value.length > this.props.maxlength) {
      event.target.value = value.substr(0, this.props.maxlength);
    }
  };
  updateChips = event => {
    if (!this.props.max || this.state.chips.length < this.props.max) {
      const value = event.target.value;
      if (!value) {
        return;
      }

      const chip = value.trim();
      if (chip && this.state.chips.indexOf(chip) < 0) {
        this.setChips([...this.state.chips, chip]);
      }
    }
    // TODO not cool
    event.target.value = '';
  };
  handleDeleteChip = chip => {
    const index = this.state.chips.indexOf(chip);

    if (index >= 0) {
      this.setChips(filter(c => c !== chip, this.state.chips));
    }
  };
  focusInput = event => {
    let children = event.target.children;

    if (children.length) children[children.length - 1].focus();
  };

  render() {
    //noinspection JSUnusedLocalSymbols
    const { label, chips, onChange, ...props } = this.props;
    return (
      <div className="chips" onClick={this.focusInput}>
        <div className="floating-label">
          <span>{label}</span>
        </div>
        <div className="chips-container">
          {map(
            c => (
              <div className="chip" key={c}>
                <Chip onRequestDelete={() => this.handleDeleteChip(c)}>{c}</Chip>
              </div>
            ),
            this.state.chips
          )}
        </div>
        <div>
          <TextField
            className={'chips-input'}
            name={'displayedTags'}
            onKeyDown={this.onKeyDown}
            onKeyUp={this.clearInvalidChars}
            fullWidth
            {...props}
          />
        </div>
      </div>
    );
  }
}

export default Chips;



// WEBPACK FOOTER //
// ./src/components/forms/TextTag.js